/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Billing_Grant_SubmitInputs */

const cs_billing_grant_submit = /** @type {(inputs: Billing_Grant_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Přidat`)
};

const en_billing_grant_submit = /** @type {(inputs: Billing_Grant_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grant`)
};

/**
* | output |
* | --- |
* | "Grant" |
*
* @param {Billing_Grant_SubmitInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const billing_grant_submit = /** @type {((inputs?: Billing_Grant_SubmitInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Billing_Grant_SubmitInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_billing_grant_submit(inputs)
	return cs_billing_grant_submit(inputs)
});